import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import { scrollBehavior } from '@/lib/motion';
import { ROUTES } from '@/routes/paths';

// Логотип лежит в public/ → ссылаемся URL-строкой (Vite не обрабатывает public-ассеты через import).
const LOGO_URL = '/logo.svg';

interface LogoProps {
  readonly to?: string;
  readonly height?: number;
  // Вертикальный сдвиг картинки (px) без изменения раскладки. Надпись в SVG сидит в нижней
  // половине — в шапке используем offsetY=-3, чтобы «DATA1861» была на уровне пунктов меню.
  readonly offsetY?: number;
}

// Фирменный логотип «Дата 1861». Ведёт на главную и скроллит страницу в самый верх (конвенция §6).
export default function Logo({ to = ROUTES.HOME, height = 28, offsetY = 0 }: LogoProps) {
  const { t } = useTranslation();
  const location = useLocation();

  function handleClick(): void {
    // Уже на целевой странице — просто наверх; при переходе прокрутку сбросит RouteShell.
    if (location.pathname === to) {
      window.scrollTo({ top: 0, behavior: scrollBehavior() });
    }
  }

  return (
    <Link to={to} onClick={handleClick} aria-label={t('app.name')} style={{ display: 'inline-flex' }}>
      <img
        src={LOGO_URL}
        alt={t('app.name')}
        height={height}
        style={offsetY ? { transform: `translateY(${offsetY}px)` } : undefined}
      />
    </Link>
  );
}
